import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader, StatBadge } from "@/components/admin/AdminLayout";
import { AlertTriangle, FileText } from "lucide-react";

export default function Documents() {
  const [alerts, setAlerts] = useState([]);
  useEffect(() => { api.get("/admin/dashboard/document-alerts").then((r) => setAlerts(r.data)); }, []);
  const expired = alerts.filter(a => a.status === "expired");
  const expiring = alerts.filter(a => a.status === "expiring");
  return (
    <div className="p-10 max-w-[1400px]">
      <PageHeader eyebrow="Compliance" title="Documents" description="Insurance, RNAAT, criminal records, vehicle inspection — track and renew before expiry." />

      <div className="grid grid-cols-3 gap-5 mb-8">
        <Kpi l="Expired" v={expired.length} accent="text-red-400" />
        <Kpi l="Expiring in 30d" v={expiring.length} accent="text-amber-400" />
        <Kpi l="Valid" v="—" sub="Auto-monitored" />
      </div>

      <div className="border border-slate-200 bg-white">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-slate-200 label-caps text-left">
              <th className="p-4">Entity</th>
              <th className="p-4">Type</th>
              <th className="p-4">Document</th>
              <th className="p-4">Expiry</th>
              <th className="p-4">Status</th>
            </tr>
          </thead>
          <tbody>
            {alerts.length === 0 && <tr><td colSpan={5} className="p-16 text-center text-slate-500">All documents valid.</td></tr>}
            {alerts.map((a, i) => (
              <tr key={i} className="border-b border-slate-200">
                <td className="p-4 text-[#0a0f1e]">{a.entity_name}</td>
                <td className="p-4 text-xs uppercase text-slate-500">{a.entity_type}</td>
                <td className="p-4 text-xs uppercase text-slate-700 flex items-center gap-2"><FileText className="w-3 h-3" />{a.document_type}</td>
                <td className="p-4 font-mono text-slate-700">{a.expiry_date}</td>
                <td className="p-4"><StatBadge status={a.status} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
function Kpi({ l, v, sub, accent }) {
  return (
    <div className="border border-slate-200 bg-white p-6">
      <div className="flex justify-between mb-3"><span className="label-caps">{l}</span><AlertTriangle className={`w-4 h-4 ${accent || "text-slate-500"}`} /></div>
      <div className={`font-display text-3xl ${accent || "text-[#0a0f1e]"}`}>{v}</div>
      {sub && <div className="text-xs text-slate-500 mt-2">{sub}</div>}
    </div>
  );
}
